import { useController, Control } from 'react-hook-form';
import BaseImageRadio, { OptionImageRadio } from './BaseImageRadio';

type ReactHookFormImageRadioProps = {
  name: string;
  control: Control<any>;
  options: OptionImageRadio[];
  disabled?: boolean;
};

export default function ReactHookFormImageRadio({
  name,
  control,
  options,
  disabled,
}: ReactHookFormImageRadioProps) {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <div>
      <BaseImageRadio
        name={name}
        value={value}
        onChange={onChange}
        options={options}
        disabled={disabled}
      />
      {error?.message && <p className="text-red-500 text-xs mt-1">{error.message}</p>}
    </div>
  );
}
